import { Platform } from 'react-native'
import { GpsBounds } from 'infra/type.ts'

export const IS_DEV = __DEV__
// dev 에서 로컬 백엔드를 쓰려면 API_BASE_URL=http://localhost:8000 pnpm web
// (web 은 webpack DefinePlugin 주입, native 는 미주입 → prod fallback)
export const SERVER_BASE_URL = !IS_DEV
  ? 'https://api.go-go.space'
  : process.env.API_BASE_URL || 'https://api.go-go.space'
export const BACK_BUTTON_EXIT_RESET_TIME = 1000
export enum OS {
  ANDROID = 'android',
  IOS = 'ios',
  WEB = 'web',
}
export const CURRENT_OS: OS =
  Platform.OS === 'web' ? OS.WEB : Platform.OS === 'ios' ? OS.IOS : OS.ANDROID
export const KOREA_CENTER = {
  latitude: 36.4,
  longitude: 127.8,
  zoom: 5.5,
  tilt: 0,
  bearing: 0,
}
export const ALL_KOREA_BOUNDS: GpsBounds = {
  maxLat: 38.6,
  maxLng: 131,
  minLat: 33,
  minLng: 124,
}

export const zoomToDelta = (zoom: number) => {
  const longitudeDelta = 360 / Math.pow(2, zoom)
  const latitudeDelta = longitudeDelta // 위도 보정 X (적도 기준)
  return { latitudeDelta, longitudeDelta }
}

export const DEFAULT_ZOOM = zoomToDelta(15)
export const AREA_ZOOM = {
  latitudeDelta: 0.05,
  longitudeDelta: 0.025,
}
export const TWO_BLOCK_ZOOM = {
  latitudeDelta: 0.0029,
  longitudeDelta: 0.0014,
}

export const BOTTOM_VIEW_HORIZONTAL_DISTANCE = 20
export const BOTTOM_VIEW_BOTTOM_DISTANCE = 28
